import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@pulpo/app-config';
import ApiService from './api.service.abstract';
import { ProductTranslation } from 'libs/pulpo-models/src/lib/product/product-translation.model';

@Injectable({ providedIn: 'root' })
export class ProductTranslationService extends ApiService<ProductTranslation> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'api/product-translations');
  }

  findForProduct(id: number): Observable<HttpResponse<ProductTranslation[]>> {
    return this.http.get<ProductTranslation[]>(
      `${this.url}/${this.endpoint}/product?productId=${id}`,
      { observe: 'response' }
    );
  }
}
